export enum PDF_TYPE {
	RECEIPT = 'ЄК',
	PAYMENT = 'КО',
};
